import { Component, EventEmitter, Output } from '@angular/core';
import { COMPONENT_NAME, EVENT_TYPE } from '@app/constants/message.constants';
import { MessageAction } from '@app/models/message-action.model';
import { MessageComponent } from '@app/models/message-base.component';

@Component({
  selector: 'app-send-email',
  templateUrl: './send-email.component.html',
  styleUrls: ['./send-email.component.scss']
})
export class SendEmailComponent extends MessageComponent {
  @Output() onMessageAction = new EventEmitter<MessageAction>();
  override type = COMPONENT_NAME.SEND_EMAIL;

  onSendCopyToEmail() {
    this.enabledButtons = false;

    this.onMessageAction.emit({ type: EVENT_TYPE.SHOULD_SEND_EMAIL, value: true });
  }

  onNotSendCopyToEmail() {
    this.enabledButtons = false;

    this.onMessageAction.emit({ type: EVENT_TYPE.SHOULD_SEND_EMAIL, value: false });
  }
}
